import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-mevo',
  templateUrl: './header-mevo.component.html',
  styleUrls: ['./header-mevo.component.scss']
})
export class HeaderMevoComponent {
  isMobile = false;

  constructor() {
    this.getScreenSize();
  }

  @HostListener('window:resize')
  private getScreenSize() {
    const { innerWidth: width } = window;
    this.isMobile = width <= 450;
  }
}
